import { LockScroll } from './LockScroll.js';
import {throttle} from "./Util";

export class PopupBottom {
    constructor() {
        this.lockScroll = new LockScroll;

        this.bindEvents();
    }

    bindEvents() {
        $('.js-open-popup-bottom').on('click', (e) => {
            e.stopPropagation();
            e.preventDefault();

            // Если у попапа есть какой-то параметр в data-popup-name, значит хотим открыть не попап по умолчанию, а какой-то особенный
            const $element = $(e.target).is('.js-open-popup-bottom') ? $(e.target) : $(e.target).closest('.js-open-popup-bottom');
            const popupName = $element.data('popup-name') ? $element.data('popup-name') : '';

            if (popupName.length !== 0) {
                $(`.js-popup-bottom[data-popup-name="${popupName}"]`).addClass('_open');
            } else {
                $('.js-popup-bottom:not([data-popup-name])').addClass('_open');
            }

            //$('.js-popup-bottom').addClass('_open');
        });

        $('.js-close-popup-bottom').on('click', () => {
            // если пользователь закрывает попап, пишем в localStorage, чтобы больше его не показывать
            localStorage.setItem('isSubscribe', 'true');

            $('.js-popup-bottom').removeClass('_open');
            App.D.trigger('form:reset');
        });
    }
}

let popupBottom;

App.W.on('barba:afterEnter', () => {
    popupBottom = new PopupBottom();
});

App.W.on('barba:leave', () => {
    try {
        popupBottom.destroy();
    } catch(error) { }
});


/* Открывает попап подписки */
function openSubscribePopup(typeOpen) {
    // Если в эту сессию еще не показывали попап, то показываем
    if (sessionStorage.getItem('showenPopup') === null) {
        $('.js-open-popup-bottom[data-popup-name="subscribe"]').trigger('click');
        $('.js-popup-bottom[data-popup-name="subscribe"]').addClass('_auto-opened');
        $('.js-popup-bottom[data-popup-name="subscribe"]').attr('data-open-type', typeOpen);
        sessionStorage.setItem('showenPopup', 'true');
    }
}

/* Если попап был открыт программно, то закрываем его */
export function closeSubscribePopup() {
    const $subscribePopup = $('.js-popup-bottom[data-popup-name="subscribe"]');

    if ($subscribePopup.is('._auto-opened')) {
        $subscribePopup.removeClass('_auto-opened').find('.js-close-popup-bottom').trigger('click');
    }
}

export function checkSubscribePopupTrigger() {
    if (localStorage.getItem('isSubscribe') === null) {
        setTimeout(function () {
            // Показываем попап подписки, если просмотрели больше 3-х страниц
            watchThirdPage(3);

            // Показываем попап подписки, если более 1 минуты на сайте и если это не страница подписки
            if(!App.H.hasClass('page-subscribe')) {
                watchSomeTime(1);
            }

            // Показываем попап подписки, если просмотрели более 2-х кейсов
            if (App.H.is('.page-case')) {
                watchSomeCases(2);
            }

            // Показываем попап подписки, если доскролили до конца главную, об агентстве или страницу портфолио
            scrollForPageEnd(['page-main', 'page-about', 'page-category']);
        }, 3000);
    } else {
        $('.js-popup-bottom[data-popup-name="subscribe"]').addClass('subscribe-active');
    }
}


//Глубина просмотра страницы
function watchThirdPage(pageCount) {
    const pageArrValue = localStorage.getItem('pageArr');
    const currUrl = location.pathname;
    let pageArr = pageArrValue ? pageArrValue.split(':') : [];

    // если такой страницы еще нет в массиве, то добавялем
    if ($.inArray(currUrl, pageArr) === -1) {
        pageArr.push(currUrl);
    }

    // если текущее кол-во просмотренных страниц больше, чем задано, то показываем попап, кроме страницы подписки
    if ((pageArr.length >= pageCount) && !App.H.hasClass('page-subscribe')) {
        openSubscribePopup('view-three-pages');
    } else { // запоминаем текущую страницу только если кол-во просмотренных страниц меньше заданного, чтобы не писать в localstorage лишнего
        localStorage.setItem('pageArr', pageArr.join(':'));
    }
}

// Более 1 минуты на сайте
function watchSomeTime(timeInterval) {
    setTimeout(openSubscribePopup, timeInterval * 60 * 1000, 'minute');
}

// Скролл до конца главной, агентства, разделов портфолио
function scrollForPageEnd(classesArr) {
    const htmlClassArr = App.H.attr('class').split(' ');

    for (let i = 0; i < classesArr.length; i++) {
        // если это страница с нужным классом, то отслеживаем скролл
        if ($.inArray(classesArr[i], htmlClassArr) !== -1) {
            scrollPageEndWatcher();
            break;
        }
    }
}

// Просмотр 2 кейсов до конца
function watchSomeCases(casesCount) {
    const $pageWrap = $('.wrap-page');
    const $footerWrap = $('.footer');
    const $preFooterWrap = $('.get-in-touch');

    App.W.on('scroll.page', throttle(function () {
        if (App.W.scrollTop() > $pageWrap.outerHeight() - App.W.outerHeight() - parseInt($footerWrap.length ? $footerWrap.outerHeight() : 0) - parseInt($preFooterWrap.length ? $preFooterWrap.outerHeight() : 0)) {
            const pageArrValue = localStorage.getItem('watchedCases');
            const currUrl = location.pathname;

            let pageArr = pageArrValue ? pageArrValue.split(':') : [];

            // если такой страницы еще нет в массиве, то добавялем
            if ($.inArray(currUrl, pageArr) === -1) {
                pageArr.push(currUrl);
            }

            // если текущее кол-во просмотренных страниц больше, чем задано, то показываем попап
            if (pageArr.length >= casesCount) {
                openSubscribePopup('view-two-cases');
            } else { // запоминаем текущую страницу только если кол-во просмотренных страниц меньше заданного, чтобы не писать в localstorage лишнего
                localStorage.setItem('watchedCases', pageArr.join(':'));
            }

            App.W.off('scroll.page');
        }
    }, 300));
}

function scrollPageEndWatcher() {
    const $pageWrap = $('.wrap-page');
    const $footerWrap = $('.footer');
    const $preFooterWrap = $('.get-in-touch');

    App.W.on('scroll.page', throttle(function () {
        if (App.W.scrollTop() > $pageWrap.outerHeight() - App.W.outerHeight() - parseInt($footerWrap.length ? $footerWrap.outerHeight() : 0) - parseInt($preFooterWrap.length ? $preFooterWrap.outerHeight() : 0)) {
            openSubscribePopup('page-down-scroll');
            App.W.off('scroll.page');
        }
    }, 300));
}



// WEBPACK FOOTER //
// ./_src/js/modules/PopupBottom.js